<!-- TODO -->

<!-- <ek-dialog-header>
    <span>{{ userName }}</span>
</ek-dialog-header> -->

<ek-dialog-body class="p-1 text-gray-700 flex justify-center items-center text-center h-full w-full overflow-hidden">
    <!-- <ek-icon [icon]="'account_circle'" style="width: 5rem;" /> -->
    <h4 style="color: black; font-weight: 400;">
        {{ userName }}
    </h4>
</ek-dialog-body>

<ek-dialog-footer>
    <ng-container ngProjectAs="[center]">
        <ek-button (click)="onConfirm()" [label]="'Esci' | translate" [ekStyle]="'outlined'"
            [severity]="'success'"></ek-button>
    </ng-container>
</ek-dialog-footer>

<!-- <div class="flex flex-col items-center w-full">
    <div class="w-full px-32">
        <ek-divider [layout]="'horizontal'"></ek-divider>
    </div>
    <div class="flex justify-center items-center gap-8">
        <ek-button class="mr-4"  [label]="'policy'" [chip]="true" ekStyle="text" [severity]="'success'"></ek-button>
        <ek-button class="mr-4"  [label]="'cookies'" [chip]="true" ekStyle="text" [severity]="'success'"></ek-button>
    </div>
</div> -->